import {theme} from "Theme";
import Typography from "@mui/material/Typography";

const LightHeading = ({children}) => {
    return (
        <Typography
            component="span"
            variant="overline"
            lineHeight={1}
            fontSize={14}
            color={theme.palette.grey[600]}
            ml={1}
        >
            {children}
        </Typography>
    );
};

export default LightHeading;
